<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="8">
            <div id="header">
              <h1 class="header-title">
                <chevron @click="$router.push({name: 'Workspace'})"/>
                {{ $t('health.recipe.title') }}
              </h1>
            </div>
          </grid-col>
        </grid-row>

        <grid-row column-align="center" class="margin-top-xxl">
          <grid-col col-size="8">
            <div class="center-horizontal">

              <safe-router-link to="/recipe/noneditable" class="nav__menu-item">
                <div class="recipe-card">
                  <div class="recipe-card-icon-wrapper">
                    <font-awesome-icon
                      :icon="icons.hatChef"
                      class="recipe-card-icon-main"/>
                  </div>
                  <div class="recipe-card-title">
                    {{ $t('health.recipe.tabs.glucovibes') }}
                  </div>
                </div>
              </safe-router-link>

              <safe-router-link to="/recipe/mine" class="nav__menu-item">
                <div class="recipe-card">
                  <div class="recipe-card-icon-wrapper">
                    <font-awesome-icon
                      :icon="icons.hatChef"
                      class="recipe-card-icon-main"/>
                    <font-awesome-icon
                      :icon="icons.bookmark"
                      class="recipe-card-icon-badge recipe-card-icon-badge--bookmark"/>
                  </div>
                  <div class="recipe-card-title">
                    {{ $t('health.recipe.tabs.mine') }}
                  </div>
                </div>
              </safe-router-link>

              <safe-router-link to="/recipe/favorites" class="nav__menu-item">
                <div class="recipe-card">
                  <div class="recipe-card-icon-wrapper">
                    <font-awesome-icon
                      :icon="icons.hatChef"
                      class="recipe-card-icon-main"/>
                    <font-awesome-icon
                      :icon="icons.star"
                      class="recipe-card-icon-badge recipe-card-icon-badge--star"/>
                  </div>
                  <div class="recipe-card-title">
                    {{ $t('health.recipe.tabs.favorites') }}
                  </div>
                </div>
              </safe-router-link>

              <a class="nav__menu-item" @click="createRecipe">
                <div class="recipe-card">
                  <div class="recipe-card-icon-wrapper">
                    <font-awesome-icon
                      :icon="icons.hatChef"
                      class="recipe-card-icon-main"/>
                    <font-awesome-icon
                      :icon="icons.pencil"
                      class="recipe-card-icon-badge recipe-card-icon-badge--pencil"/>
                  </div>
                  <div class="recipe-card-title">
                    {{ $t('health.recipe.tabs.new') }}
                  </div>
                </div>
              </a>

            </div>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import {faHatChef, faStar, faPencil, faBookmark} from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import SafeRouterLink from '@/components/shared/SafeRouterLink';
import Chevron from '@/components/shared/Chevron';
import {mapGetters} from 'vuex';

export default {
  name: 'RecipeList',
  components: {
    SafeRouterLink,
    MainLayout,
    GridRow,
    GridCol,
    FontAwesomeIcon,
    Chevron
  },
  data () {
    return {
      icons: {
        hatChef: faHatChef,
        star: faStar,
        pencil: faPencil,
        bookmark: faBookmark
      }
    };
  },
  computed: {
    ...mapGetters([
      'getUserAccount'
    ]),
    getBreadcrumb () {
      return [
        {link: '/workspace', name: this.$t('menu.workspace')},
        {link: '/recipe', name: this.$t('health.recipe.title'), disabled: true}
      ];
    }
  },
  methods: {
    createRecipe () {
      this.$router.push({name: 'EditRecipe', params: {mode: 'create', user: this.getUserAccount}});
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

.center-horizontal {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.recipe-card {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  vertical-align: top;
  text-align: center;
  background-color: $black-light9;
  border: solid 0.2rem $black-light9;
  border-radius: $radius;
  height: 15rem;
  width: 15rem;
  color: $secondary;
  padding: 1rem;
  cursor: pointer;
  transition: border-color 0.15s ease;
}

.recipe-card:hover {
  border: solid 0.2rem $black-light5;
}

.recipe-card-icon-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 1rem;
}

.recipe-card-icon-main {
  font-size: 7rem;
}

.recipe-card-icon-badge {
  position: absolute;
  font-size: 2.8rem;
  top: -0.5rem;
  right: -1.2rem;
}

.recipe-card-icon-badge--star {
  color: #f5b400;
}

.recipe-card-icon-badge--pencil {
  color: $secondary;
  top: -0.3rem;
  right: -1.5rem;
  transform: rotate(35deg);
}

.recipe-card-icon-badge--bookmark {
  color: $secondary;
  top: -0.3rem;
  right: -0.8rem;
}

.recipe-card-title {
  font-size: 1.3rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/recipe/RecipeList.vue